export default require('./VolumeControl').default
